import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import usePendingHandler from '@shared/usePendingHandler';
import useApiError from '@di-shared/features/common/useApiError';
import {diApi} from '@di-shared/api/di';

export interface SafeDrivingResetRecheckBottomSheetKrProps {
  vin: string;
}

function SafeDrivingResetRecheckBottomSheetKr({vin}: SafeDrivingResetRecheckBottomSheetKrProps) {
  const {t} = useInferableTranslation();
  const {resolveError} = useApiError();

  const [resetSafeDriving] = usePendingHandler(
    async () => {
      // @ts-ignore
      await diApi.agreementsController.updateAgreements({vin});
      window.bottomSheetClose(true);
    },
    async (error) => {
      await resolveError(error);
    }
  );

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T20179')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20180')}</strong>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => resetSafeDriving()}
          >
            {t('T20181')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('T20119')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SafeDrivingResetRecheckBottomSheetKr;
